module.exports = __webpack_public_path__ + "static/media/heroBack3.3bb5f4f9.svg";